import React, { useEffect, useState, useMemo, useRef } from "react";
import Activities from "../../components/Activities";
import {
  ContentFilters,
  ContentHeaderActivity,
  GeneralStyle,
  TitleActivity,
  useStyles,
} from "./ActivitiesContainer.styled";
import { Col, Row } from "react-bootstrap";
import GeneralFiltersContainer from "../GeneralFiltersContainer/GeneralFiltersContainer";
import {
  ALL_PUBLIC_EVENT_LIST,
} from "../../GraphQL/Queries";
import { useLazyQuery } from "@apollo/client";
import moment from "moment";
import { clientWellness } from "../../App";
import HeaderComponent from "../../components/Header/Header";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-header-icon.svg";
import SearchComponent from "../../components/SearchComponent/SearchComponent";

const ActivitiesContainer = () => {
  const classes = useStyles();
  const [filtered, setFiltered] = useState(false);
  const [dataFilter, setDataFilter] = useState({});
  const [events, setEvents] = useState([]);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [page, setPage] = useState(0);
  const [allPages, setAllPages] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = useMemo(() => [5, 10, 25], []);
  const [searchText, setSearchText] = useState("");
  const rSearch = useRef();

  const filtersViews = {
    languages: true,
    speakers: true,
    eventCategories: true,
    initialDate: true,
    finalDate: true,
    search: {
      show: false,
      label: "Search by name",
    },
  };

  useEffect(() => {
    filterEvents();
  }, [searchText]);

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  const [
    runQueryAllPublicEventList,
    {
      loading: loadingAllPublicEventList,
      error: errorAllPublicEventList,
    },
  ] = useLazyQuery(ALL_PUBLIC_EVENT_LIST, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
    },
  });

  let filterEvents = () => {
    setFiltered(true);
    runQueryAllPublicEventList({
      variables: {
        languagesId: dataFilter.language ? dataFilter.language : [],
        speakersId: dataFilter.speaker ? dataFilter.speaker : [],
        startDate: dataFilter.initialDate
          ? dataFilter.initialDate
          : new Date().toISOString(),
        finishDate: dataFilter.finalDate ? dataFilter.finalDate : null,
        categoryId: dataFilter.eventCategory ? dataFilter.eventCategory : null,
        searchBy: searchText ? searchText : "",
        first: rowsPerPage,
      },
    });
  };

  const sortByDateTime = (a, b) => {
    if (a.startTime < b.startTime) {
      return -1;
    } else if (a.startTime > b.startTime) {
      return 1;
    } else {
      return 0;
    }
  };

  const asignData = (data) => {
    setAllPages(data.allPublicEventsList.totalCount);
    if (data.allPublicEventsList.pageInfo.hasNextPage === true) {
      setEndCursor(data.allPublicEventsList.pageInfo.endCursor);
    }
    if (data.allPublicEventsList.pageInfo.hasPreviousPage === true) {
      setStartCursor(data.allPublicEventsList.pageInfo.startCursor);
    }

    const newEvents = data?.allPublicEventsList?.nodes.map((element) => {
      let eventData = {
        idEvent: element?.idEvent,
        eventTitle: element?.eventName,
        speakerName:
          element?.wellnessSpeakerEvents[0]?.idSpeakerNavigation?.speakerName,
        jobPosition:
          element?.wellnessSpeakerEvents[0]?.idSpeakerNavigation?.position,
        startDate: moment(element?.startDate, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        ),
        startTime: element?.startDate,
        endTime: element?.finishDate,
        attendees: element?.totalAccepted,
        language: element?.idLanguage,
        urlPhoto: element?.urlPhoto,
        description: element?.description,
        createUser: element?.createUser,
        isFull: element?.isFull,
        recurrenceEndDate: element?.recurrenceEndDate,
        recurrencePattern: element?.recurrencePattern,
      };
      return eventData;
    });
    newEvents.sort(sortByDateTime);
    setEvents(newEvents);
  };

  useEffect(() => {
    if (!filtered && events.length === 0) {
      filterEvents();
    }
  }, [filtered, rowsPerPage, events]);

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
        runQueryAllPublicEventList({
          variables: {
            first: rowsPerPage,
            after: endCursor,
            languagesId: dataFilter.language ? dataFilter.language : [],
            speakersId: dataFilter.speaker ? dataFilter.speaker : [],
            startDate: dataFilter.initialDate
              ? dataFilter.initialDate
              : new Date().toISOString(),
            finishDate: dataFilter.finalDate ? dataFilter.finalDate : null,
            categoryId: dataFilter.eventCategory ? dataFilter.eventCategory : null,
            searchBy: searchText ? searchText : "",
          },
          context: { clientName: "LinkUsers" },
        });
      }
    if (newPage < page) {
        runQueryAllPublicEventList({
          variables: {
            last: rowsPerPage,
            before: startCursor,
            languagesId: dataFilter.language ? dataFilter.language : [],
            speakersId: dataFilter.speaker ? dataFilter.speaker : [],
            startDate: dataFilter.initialDate
              ? dataFilter.initialDate
              : new Date().toISOString(),
            finishDate: dataFilter.finalDate ? dataFilter.finalDate : null,
            categoryId: dataFilter.eventCategory ? dataFilter.eventCategory : null,
            searchBy: searchText ? searchText : "",
          },
          context: { clientName: "LinkUsers" },
        });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value ? parseInt(event.target.value) : 5);
    setPage(0);
    runQueryAllPublicEventList({
      variables: {
        languagesId: dataFilter.language ? dataFilter.language : [],
        speakersId: dataFilter.speaker ? dataFilter.speaker : [],
        startDate: dataFilter.initialDate
          ? dataFilter.initialDate
          : new Date().toISOString(),
        finishDate: dataFilter.finalDate ? dataFilter.finalDate : null,
        categoryId: dataFilter.eventCategory ? dataFilter.eventCategory : null,
        searchBy: searchText ? searchText : "",
        first: event.target.value ? parseInt(event.target.value) : 5,
      },
    });
  };


  return (
    <GeneralStyle className={classes.contentForActivities}>
      <Row>
        <HeaderComponent Icon={CalendarIcon} text={"My calendar"} />
      </Row>
      <Row className={classes.contentForActivities}>
        <Col md={12} className={"mx-4 mt-3"}>
          <ContentHeaderActivity>
            <TitleActivity>Activities</TitleActivity>{" "}
          </ContentHeaderActivity>
        </Col>
      </Row>
      <hr style={{ margin: "1% 2%", width: "96%" }} />
      <Row>
        <Col
          md={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <ContentFilters>
            <GeneralFiltersContainer
              filtersViews={filtersViews}
              FilterEvents={filterEvents}
              setDataFilter={setDataFilter}
              filtered={filtered}
              setFiltered={setFiltered}
              showTopHR={false}
            />
          </ContentFilters>
          <SearchComponent
            handleSearch={handleSearch}
            rSearch={rSearch}
            setSearchText={setSearchText}
          />
        </Col>
        <Col md={12}>
          <Activities
            loadingAllPublicEventList={loadingAllPublicEventList}
            errorAllPublicEventList={errorAllPublicEventList}
            events={events}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            allPages={allPages}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Col>
      </Row>
    </GeneralStyle>
  );
};

export default ActivitiesContainer;
